import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import FaqContent from './components/FaqContent';

export default function FaqPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '常見問題｜保健食品代工 FAQ｜康永生技',
    description: '保健食品代工常見問題解答：品牌建立、少量代工、法規合規、通路銷售、生產流程、合作信任、出口市場等7大主題分類。',
    keywords: '保健食品FAQ,代工常見問題,ODM問題,OEM問題,品牌合作問題,康永FAQ',
    lang: 'zh-TW',
    canonicalPath: '/cooperation/faq',
  });

  return (
    <Layout>
      <SEOJsonLd
        type="FAQPage"
        pageTitle="常見問題｜保健食品代工 FAQ｜康永生技"
        pageDescription="保健食品代工常見問題解答：品牌建立、少量代工、法規合規、通路銷售、生產流程、合作信任、出口市場等7大主題分類。"
        pageUrl={`${siteUrl}/cooperation/faq`}
        faqData={[
          { question: '對保健食品完全沒概念，康永 ODM 適合我嗎？', answer: '非常適合。康永為新品牌、電商品牌、網紅、團購主設計了低門檻的 ODM 流程，從市場定位、功能方向、配方設計、法規審查到量產上市，都有專業團隊全程協助。' },
          { question: '我有粉絲或團購通路，但不確定要做哪種產品，可以協助嗎？', answer: '我們會分析受眾輪廓（年齡、性別、生活型態、銷售場景），協助選擇適合的功能方向和劑型，避開不好賣或高法規風險的產品。' },
          { question: 'ODM 產品會不會跟市場上的太像？', answer: '不會。我們提供客製化配方調整和原料組合建議，避免使用市場上的公版配方，讓產品具有市場差異化和品牌故事性。' },
          { question: '我還沒有具體配方想法，可以跟康永合作嗎？', answer: '當然可以。我們可以根據您的銷售通路、目標客群，提供市場分析和配方建議。針對不同階段的品牌，我們有兩大核心方案：獨家專屬配方（從零開發）以及成熟配方應用（多款經市場驗證的熱銷配方與成熟半成品）。' },
          { question: '預算有限，可以少量生產嗎？', answer: '可以。我們支援少量試單、低庫存啟動方案，適合新品牌、直播主、團購主先測試市場反應。各劑型的最低訂購量（MOQ）詳情，請參閱各類劑型頁面。' },
          { question: '萬一產品賣不好怎麼辦？', answer: '我們會協助您在初期避開高風險的功能宣稱和原料，同時推薦市場接受度較高的產品方向，降低滯銷風險。' },
          { question: '可以先拿到樣品確認口感和效果嗎？', answer: '可以。每個 ODM 專案皆可安排樣品試製和配方微調，讓您在量產前親自確認口感和配方方向。個別產品效果因產品屬性與個人體質而異，部分效果可在樣品階段驗證。打樣費用詳情請參閱各類劑型頁面。' },
          { question: '食品不能宣稱療效，該怎麼寫行銷文案？', answer: '我們熟悉台灣食品法規和合法用語，可協助調整商品名稱、包裝文案、銷售話術，避免違規風險。' },
          { question: '可以協助食品標示和營養標示計算嗎？', answer: '可以。我們可以協助完整的食品標示、營養標示計算及文案審查，符合食品法規。' },
          { question: 'KOL 直播或團購的銷售腳本會觸法嗎？', answer: '我們可以提供合法用語方向和建議，協助您在直播和團購平台上安心銷售。' },
          { question: 'ODM 產品適合哪些銷售通路？', answer: '電商平台、直播銷售、社團團購、傳直銷體系、寵物通路、醫療相關機構都非常適合。' },
          { question: '有提供產品教育或銷售素材嗎？', answer: '我們可提供產品特點說明、原料特色介紹與內部教育訓練資料。' },
          { question: '可以製作寵物保健品嗎？', answer: '可以。我們有寵物保健品的製作經驗，可針對犬貓兔提供配方設計，並依相關法規生產。' },
          { question: '生產大約需要多久時間？', answer: '一般產品生產約 30-60 工作天，初次合作由於需確認項目較多，時間可能稍長。實際時程依產品複雜度而異。' },
          { question: '工廠有國際認證嗎？', answer: '我們的工廠通過國際 ISO 22000 及 HACCP 認證，並可提供生產證明，確保產品生產品質。' },
          { question: '可以支援外銷或跨境銷售嗎？', answer: '我們可以協助相關評估，但需依目標市場法規進一步確認。' },
          { question: '可以提供第三方檢驗認證嗎？', answer: '可以。我們可以依照客戶需求，安排第三方公正單位（如 SGS）進行檢驗。' },
          { question: '需要自行準備包裝盒子和設計嗎？', answer: '不需要。我們提供完整的包裝設計印刷一條龍服務，從彩盒、鋁箔袋、瓶器到 PTP 包裝皆可客製，並協助確認食品標示法規要求。包裝詳情請參考包裝設計頁面。' },
          { question: '可以簽訂保密協議（NDA）嗎？', answer: '可以。我們重視客戶配方和商業資訊的安全，可以依需求簽訂保密協議。' },
          { question: '哪些類型的客戶最適合跟康永合作？', answer: '新創品牌、電商經營者、網紅與KOL、團購主、傳直銷通路、寵物品牌、醫療相關機構，都歡迎與我們洽談合作。' },
          { question: '外銷是否需要調整配方或標示？', answer: '需要視目標國家而定。不同國家對食品原料、添加量、標示語言與格式有不同的要求，我們可以協助前期評估。' },
          { question: '可以協助規劃多國版本的產品嗎？', answer: '可以。我們可以針對不同市場需求，協助設計同一產品的多版本配方或標示版本，讓品牌可以彈性拓展不同國際通路。' },
        ]}
      />
      <FaqContent />
    </Layout>
  );
}